import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "300",
  "slug": "spot-thailand-from-satellite-imagery",
  "title": "How to Recognise Thailand in Satellite Images",
  "excerpt": "Thailand has a broad central lowland around the Chao Phraya, higher terrain in the north, and the Khorat Plateau in the northeast.",
  "date": "2026-04-13",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/thailand.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Thailand has a broad central lowland around the Chao Phraya, higher terrain in the north, and the Khorat Plateau in the northeast. The country extends south along a peninsula between the Andaman Sea and Gulf of Thailand. These regions require different visual comparisons."
    },
    {
      "type": "heading",
      "text": "A central plain and a narrow southern peninsula"
    },
    {
      "type": "paragraph",
      "text": "Compare the central plain near Bangkok with the narrow southern peninsula. Identify where a single image would need a wider crop to show both coasts."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Rice plains also occur in Cambodia and Vietnam, and limestone coastal scenery occurs elsewhere in Southeast Asia. Use the wider peninsula or river-basin shape before treating a field pattern as national evidence."
    }
  ],
  "imageAlt": "Thailand regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
